import { render } from "./CommonMessageTextarea.vue?vue&type=template&id=225e3acf"
import script from "./CommonMessageTextarea.vue?vue&type=script&lang=js"
export * from "./CommonMessageTextarea.vue?vue&type=script&lang=js"

import "./CommonMessageTextarea.vue?vue&type=style&index=0&id=225e3acf&lang=scss"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__